import BaseAPI from '@/apis/base/baseApi';

export default class ExApi extends BaseAPI {
  apiName = 'EX';
}
